import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CopyComponent from "../../../../components/copyComponent";
import Sorting from "../../../../components/sorting";
import Toggle from "../../../../components/toggle";
import UserStatus from "../../../../components/userstatus";
import Pagination from "../../../../components/tablePagination";
import { getMediumRole } from "../../../../utils/utils";
import Checkbox from "../../Subcomponents/checkbox";
import { deleteAllUserFeedbacks, regenerateMediumSlots } from "../../../../services/admin";
import { toast } from "react-toastify";
import ToggleTestUser from "../../Subcomponents/toogletestuser";
import { setPathArray, setProfessionalPage, setProfessionalrowsPerPage } from "../../../../reducer/adminSlice";
import FraudSignalBadge from "../../../../components/fraudsignalbadge";
import MediumInfoPanel from "../MediumInfoPanel";
import ConfirmDelete from "../../Subcomponents/deleteconfirm";

export default function Professional(props) {
  const {
    professionals,
    updateUser,
    onClickHandler,
    filterListMediums,
    bulkActions,
    getPaginationData,
    professionalPage,
    professionalrowsPerPage,
    setFilterValues,
    setSearchValues,
    searchValue,
    filterValues,
    filterReset,
    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    isSearching,
    checked,
    setChecked,
    selected,
    setSelected,
  } = props;

  const navigate = useNavigate();

  const [panelMedium, setPanelMedium] = useState(null);
  const [panelDetails, setPanelDetails] = useState(null);
  const [panelLoading, setPanelLoading] = useState(false);
  const [feedbackConfirmMedium, setFeedbackConfirmMedium] = useState(null);
  const [recalculatingSlots, setRecalculatingSlots] = useState(false);

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };
  const getAvatarStyle = (name) => {
    const palettes = [
      { background: '#f5e6d8', color: '#b87040' },
      { background: '#faf0e8', color: '#c07838' },
      { background: '#eeddd0', color: '#a86030' },
      { background: '#f7ece0', color: '#d5a67b' },
      { background: '#f0e0cc', color: '#b87848' },
    ];
    const idx = name ? name.charCodeAt(0) % palettes.length : 0;
    return palettes[idx];
  };

  const { allProfessionalsCount, allProfessionalsCountPage } = useSelector((state) => state.users);

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');

  useEffect(() => {
    if (page !== null) {

      dispatch(setProfessionalPage(page));
    }
    if (rowperpage !== null) {
      dispatch(setProfessionalrowsPerPage(rowperpage));
    }
  }, [])
  let info = JSON.parse(localStorage.getItem('pagination'))
  const navigateUser = (e, id) => {
    window.renderFirst = false;
    e.stopPropagation();
    dispatch(setPathArray(id.id));
    navigate(`/profile-view/${id.id}?view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const publicViewHandler = (e, id) => {
    window.renderFirst = false
    e.stopPropagation();
    dispatch(setPathArray(id.id));
    navigate(`/public-view/${id.id}?view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const navigateEdit = (e, id) => {

    window.renderFirst = false
    if (e.target.className == "capitalize") {
      navigate(`/profile-edit/${id.id}?view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
    } else {
    }
  };
  const handleEditClick = (e, id) => {
    e.stopPropagation();
    window.renderFirst = false;
    navigate(`/profile-edit/${id.id}?view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };

  const checkBoxChangeHandler = (e) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      let result = professionals.map((a) => a.id);
      setSelected(result);
    } else {
      setSelected([]);
    }
  };

  // const getPaginationData = (item) => {
  //   console.log('paginationdata',item.from);
  //   getFromToData(item)
  //  };

  const deleteFeedBack = (e, prof) => {
    e.stopPropagation();
    let body = {
      medium_id: prof.id,
    };
    deleteAllUserFeedbacks(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Feedbacks Deleted Successfully", {
            position: "top-center",
          });
        }
      })
      .catch(() => { });
  };
   const navigateUserPricing = (id) => {
          window.renderFirst = false
          dispatch(setPathArray(id.id));
          navigate(`/pricing-view/${id.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
        };
  const handleScreenNameClick = function(e, item) {
    e.stopPropagation();
    setPanelMedium(item);
    setPanelDetails({ general: { phone: item.phone || '', whatsapp: item.whatsapp || '', country: item.country || '', timezone: item.timezone || '', timezone_label: item.timezone_label || '', created_at: item.created_at || '' } });
    setPanelLoading(false);
    setRecalculatingSlots(false);
  };
  const handleRecalculateSlots = function(medium) {
    if (!medium || recalculatingSlots) return;
    setRecalculatingSlots(true);
    regenerateMediumSlots(medium.id)
      .then(function(res) {
        setRecalculatingSlots(false);
        if (res && res.data && res.data.status) {
          toast.success(res.data.message || 'Slot recalculation queued', { position: 'top-center' });
        } else {
          toast.error((res && res.data && res.data.message) || 'Failed to queue slot recalculation', { position: 'top-center' });
        }
      })
      .catch(function() {
        setRecalculatingSlots(false);
        toast.error('Failed to queue slot recalculation', { position: 'top-center' });
      });
  };

  var panelActions = panelMedium ? [
    { label: 'Schedule', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/services?schedule=schedule&id=' + panelMedium.id + '&view=3&level=' + panelMedium.current_mediumship_level + '&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Schedule Status', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/schedule-status/' + panelMedium.id + '?view=3&level=' + panelMedium.current_mediumship_level + '&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&screen_Name=' + panelMedium.screen_name + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Calendar', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/availability/' + panelMedium.id + '?&view=3&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage); setPanelMedium(null); } },
  ].concat(
    ![1,2,4].includes(panelMedium.current_mediumship_level) ? [{ label: 'BackFill', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/backfill-view/' + panelMedium.id + '?view=3&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } }] : []
  ).concat([
    { label: 'View Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.open('/public-view/' + panelMedium.id, '_blank'); setPanelMedium(null); } },
    { label: 'Public View', variant: 'default', onClick: function(e) { publicViewHandler(e, panelMedium); setPanelMedium(null); } },
    { label: 'Edit Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/profile-edit/' + panelMedium.id + '?view=3&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Pricing', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; dispatch(setPathArray(panelMedium.id)); navigate('/pricing-view/' + panelMedium.id + '?view=0&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Share it Forward', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/share-it-forward/' + panelMedium.id + '?name=' + encodeURIComponent(panelMedium.screen_name || '')); setPanelMedium(null); } },
    { label: recalculatingSlots ? 'Recalculating…' : 'Recalculate Slots', variant: 'success', disabled: recalculatingSlots, onClick: function(e) { e.stopPropagation(); handleRecalculateSlots(panelMedium); } },
    { label: parseInt(panelMedium.status_name) === 4 ? 'UnRestrict' : 'Restrict', variant: 'warning', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, parseInt(panelMedium.status_name) === 4 ? 1 : 4, 'professional', ''); setPanelMedium(null); } },
    { label: 'Delete', variant: 'danger', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, 3, 'delete', ''); setPanelMedium(null); } },
    { label: 'Delete Feedbacks', variant: 'danger', onClick: function(e) { e.stopPropagation(); setFeedbackConfirmMedium(panelMedium); setPanelMedium(null); window.loadModal2('#deleteFeedbackConfirm', 'show'); } },
  ]) : [];

  return (
    <>
      {/* <div className="filter-box-row">
      <div className="left-filtr">
        <em>Show Entries</em>
        <select id="sel" name="sel">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
          <option>6</option>
          <option>7</option>
          <option>8</option>
          <option>9</option>
          <option>10</option>
        </select>
      </div>
      <div className="right-filtr">
        <div className="add-neapp">
          <a href="#">
            <img src="../images/fill-plus.png" />
            Add New Medium
          </a>
        </div>
        <div className="search-box">
          <input
            className="search-input"
            type="text"
            placeholder="Search something.."
          />
          <button className="search-btn">
            <img src="../images/search.png" />
          </button>
        </div>
        <div className="filter-box">
          <div className="btn-group dropdown-filter">
            <button
              type="button"
              className="btn btn-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src="../images/filter.png" className="filtr-img" />
              Filter by
              <img src="../images/dropdown.png" className="drop-filtr" />
            </button>
          </div>
        </div>
        <div className="menu-dot">
          <a href="#">
            <img src="../images/dote.png" />
          </a>
        </div>
      </div>
    </div> */}
      <div className="table-box-medium">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>
                <input
                  onChange={(e) => checkBoxChangeHandler(e)}
                  type="checkbox"
                  id="one"
                />
                <label htmlFor="one"></label>
                &nbsp;
              </th>
              <th>
                {" "}
                <div className="d-flex align-items-center">
                  {" "}
                  <span>Screen Name & Email</span>{" "}
                  <Sorting callApi={filterListMediums} />
                </div>
              </th>
              <th>Test User</th>
              <th>Starter Referral Code</th>
              {/* <th>Total Starter Referrals</th> */}
              <th>Approved Role</th>
              <th>Online status</th>
              <th>Enable/Disable</th>
              <th>Fraud Risk</th>
              <th>Action</th>
              {/* <th className="text-right">Actions</th> */}
              {/* <th>Action</th> */}
            </tr>
            {isSearching ? (
              <tr>
              <td colSpan="12" className="text-center py-4">
                <div className="custom-loader">
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                </div>
                <div className="loader-text mt-2">Loading mediums...</div>
              </td>
            </tr>
              )
            :professionals.length > 0 ? (
              professionals.map((professional) => (
                <tr
                  className="innr"
                >
                  <td>
                    <Checkbox
                      medium={professional}
                      status={checked}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </td>
                  <td onClick={(e) => handleScreenNameClick(e, professional)} className="pointer">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        className="medium-avatar"
                        style={professional.profile_image ? { width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', display: 'inline-flex', flexShrink: 0 } : getAvatarStyle(professional.screen_name)}
                      >
                        {professional.profile_image ? (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + professional.profile_image}
                            alt={professional.screen_name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                          />
                        ) : getInitials(professional.screen_name)}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div>
                          <span className="screen-name-link" style={{ textTransform: 'capitalize' }} onClick={(e) => handleScreenNameClick(e, professional)}>
                            {professional.screen_name ? professional.screen_name : "N/A"}
                          </span>
                          {(professional.comments != null && professional.comments !== "") && (<b style={{ fontSize: '22px' }}>*</b>)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#888', textTransform: 'none' }}>
                          {professional.email}<CopyComponent value={professional.email} />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td><ToggleTestUser
                    clientId={professional.id}
                    initialStatus={professional.test_user === 1} // Set initial toggle state
                    onStatusChange={(id, newStatus) => {
                      console.log(`Client ${id} status changed to ${newStatus ? 'on' : 'off'}`);
                      // Additional handling if necessary
                    }}/></td>
                  <td>{professional.refer_code ? professional.refer_code : "-"}</td>
                  {/* <td>{professional.number_of_uses}</td> */}
                  <td className="change">
                    <em>
                      {getMediumRole(professional.current_mediumship_level)}
                    </em>
                    {/* <a href="#">Change</a> */}
                  </td>
                  <td>
                    <UserStatus status={professional.is_available} />
                  </td>
                  <td>
                    <div className="min-width-70px ">
                      <Toggle item={professional} />
                    </div>
                  </td>
                  <td><FraudSignalBadge client={professional} userType="medium" /></td>
                  <td>
                    <button
                      onClick={(e) => handleEditClick(e, professional)}
                      style={{ padding: '5px 14px', fontSize: '12px', fontWeight: '600', background: '#d5a67b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </button>
                  </td>
                  {/* <td className="dott">
                    <img
                      className="padding-10"
                      onClick={(e) =>
                        onClickHandler(e, professional.id, "professional")
                      }
                      src="images/Unionblck.png"
                      alt="dots"
                    />
                    {professional.status && (
                      <div className="approve-btn-1 approve-btn z-index-1">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/services?schedule=schedule&id=${professional.id}&view=3&level=${professional.current_mediumship_level}&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                            );
                          }}
                        >
                          Schedule
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/schedule-status/${professional.id}?view=3&level=${professional.current_mediumship_level}&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&screen_Name=${professional.screen_name}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                            );
                          }}
                        >
                          Schedule status
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/availability/${professional.id}?&view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}`
                            );
                          }}
                        >
                          Calendar
                        </span>
                        {![1, 2, 4].includes(professional.current_mediumship_level) && (
                            <span
                            onClick={(e) => {
                              e.stopPropagation();
                              window.renderFirst = false;
                              navigate(
                              `/backfill-view/${professional.id}?view=3&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                              );
                            }}
                            >
                            BackFill
                            </span>
                          )}
                        <span onClick={(e) => navigateUser(e, professional)}>
                          View
                        </span>
                        <span
                          onClick={(e) => {
                            publicViewHandler(e, professional);
                          }}
                        >
                          Public View
                        </span>
                         <span
                            onClick={(e) => {
                            e.stopPropagation();
                            navigateUserPricing(professional);
                          }}
                        >
                          Pricing
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(
                              professional,
                              parseInt(professional.status_name) === 4 ? 1 : 4,
                              "professional",
                              ""
                            );
                          }}
                        >
                          {parseInt(professional.status_name) === 4
                            ? "UnRestrict"
                            : "Restrict"}
                        </span>

                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(professional, 3, "delete", "");
                          }}
                        >
                          Delete
                        </span>
                        <span
                          onClick={(e) => {
                            deleteFeedBack(e, professional);
                          }}
                        >
                          Delete Feedbacks
                        </span>

                      </div>
                    )}
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                      <line x1="8" y1="8" x2="16" y2="8" stroke="none"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No mediums found</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#aaa' }}>Try adjusting your filters or load all records</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Pagination
          rowsPerPageOptions={[25, 50, 100]}
          count={allProfessionalsCountPage}
          getPaginationData={getPaginationData}
          activeTab={"professionals"}
          professionalPage={professionalPage}
          professionalrowsPerPage={professionalrowsPerPage}
        />
      </div>
      <MediumInfoPanel
        medium={panelMedium}
        details={panelDetails}
        detailsLoading={panelLoading}
        onClose={() => setPanelMedium(null)}
        actions={panelActions}
      />

      <ConfirmDelete
        id="deleteFeedbackConfirm"
        deleteUser={function(e) { if (feedbackConfirmMedium) { deleteFeedBack({ stopPropagation: function(){} }, feedbackConfirmMedium); setFeedbackConfirmMedium(null); } }}
        cancelRequest={function() { setFeedbackConfirmMedium(null); }}
      />
    </>
  );
}
